import { Component, useContext, useEffect, useRef, useState, useMemo } from 'react';
import './App.css';
import { AccountContext } from './contexts/AccountContext';
import { DataGrid } from '@nokia-csf-uxr/ccfk';
import { AllCommunityModules } from '@ag-grid-community/all-modules';
import { Link, useNavigate } from 'react-router-dom';
import LoadingScreen from './components/LoadingScreen';
import { CONFIG } from './config';
import { toast, Id } from 'react-toastify';
import React from 'react';
import Button from 'react-bootstrap/esm/Button';
import { Container, Row, Col, ButtonGroup, Modal } from 'react-bootstrap';

/**
 * Class to render action buttons in the list of the user's links
 */
class BtnCellRenderer extends Component<any,any> {
  constructor(props: any) {
    super(props);
  }

  render() {
    return (
      <>
      {this.props?.data.idLink ?
        <>
          <ButtonGroup>
            <Link className='btn-sm btn' to={"/link/"+this.props.data.idLink}>Edit</Link>
            <Link className='btn-sm btn' to={"/link/"+this.props.data.idLink+"/budget"}>View budget</Link>
            <Link className='btn-sm btn' to={"/link/"+this.props.data.idLink+"/boq"}>View BoM</Link>
            <Button className="btn-sm" bsPrefix="" variant="" onClick={() => this.props.context.displayConfirmDeletion(this.props.rowIndex, this.props.data.idLink, this.props.data.name)}>Delete</Button>
          </ButtonGroup>
        </>
        : <></> }
      </>
    )
  }
}

/**
 * Data grid to display the user's links
 */
export default function WLD() {
  const ACCOUNT = useContext(AccountContext);

  const TOAST_ID = React.useRef<Id>(-1);

  const [rowData, setRowData] = useState([{}]);
  const [loading, setLoading] = useState(true);
  const [showConfirmDeletion, setShowConfirmDeletion] = useState(false);

  // states to delete data
  const [deletedLinkRowIndex, setDeletedLinkRowIndex] = useState(-1);
  const [deletedLinkId, setDeletedLinkId] = useState(-1);
  const [deletedLinkName, setDeletedLinkName] = useState("");

  const DELETON_NOTIF = () => TOAST_ID.current = toast.loading(CONFIG.sentences["home.popup.deletion_in_progress"], 
  { 
      position: "bottom-right", 
      autoClose: false 
  });

  const SUCCESSFUL_NOTIF = () => toast.update(TOAST_ID.current, 
  {
      render: CONFIG.sentences["home.popup.delete.link"], 
      position: "bottom-right",
      type: toast.TYPE.SUCCESS,
      isLoading: false,
      autoClose: 5000 
  });

  const DELETED_ERROR = () => toast.update(TOAST_ID.current, 
  {
      render: CONFIG.sentences["home.popup.deletion.problem"], 
      position: "bottom-right",
      type: toast.TYPE.ERROR, 
      isLoading: false,
      autoClose: 5000 
  });

  const WINDOWS_HEIGHT = window?.innerHeight;

  const WINDOWS_OVERHEAD = 180;

  const WINDOWS_LIST_OVERHEAD = 104;

  const DEFAULT_LINK_LIST_HEIGHT =729;

  const DEFAULT_PAGE_NUMBER = 15;

  const LINE_HEIGHT = 51;

  const GRID_API = useRef<any>(null);

  const NAVIGATE = useNavigate();

  const DATAGRID_COLUMNS_DEFS = () => [
    {
      headerName: 'Name',
      field: 'name'
    },
    {
      headerName: 'Site 1',
      field: 'site.0.name',
      sortable: false
    },
    {
      headerName: 'Site 2',
      field: 'site.1.name',
      sortable: false
    },
    {
      headerName: 'Actions',
      sortable: false,
      cellRendererFramework: BtnCellRenderer
    }
  ];

  // Get the user's links
  useEffect(() => {
    fetch(CONFIG.apiURI+"/link", { 
      method: 'GET',
      mode: "cors",
      headers: {
        Accept: 'application/json',
        "token": ACCOUNT.token
      }
      })
      .then((res) => {
        if (!res.ok) {
          if ([401, 403].includes(res.status)) {
            ACCOUNT.setIsExpired(true)
            return;
          }
        }
        return res.json()
      })
      .then((json) => {
        console.log(json)
        setRowData(json)
        setLoading(false);
      })
  }, [])

  const DELETE_ROW = (rowIndex: any) => {
    setRowData(rowData.filter((data, index) => index != rowIndex))
  }

  /**
   * JS functions to manage the modal to confirm the deletion of a link
   */
  // Close the pop-up
  const CLOSE_CONFIRM_DELETION = () => setShowConfirmDeletion(false);

  // Display the pop-up
  const displayConfirmDeletion = (rowIndex: number, linkId: number, linkName: string) => {
    setShowConfirmDeletion(true)
    
    setDeletedLinkRowIndex(rowIndex)
    setDeletedLinkId(linkId)
    setDeletedLinkName(linkName)
  }; 

  /**
   * Send the HTTP request to delete a link
   * @param rowIndex Index in the grid
   * @param linkId Link ID in the database
   */
  const confirmDeletion = () => {
    DELETON_NOTIF()

    fetch(CONFIG.apiURI+"/link/"+deletedLinkId+"/delete", { 
      method: 'POST',
      mode: "cors",
      headers: {
        Accept: 'application/json',
        "token": ACCOUNT.token
      }
      })
    .then((res) => res.json())
    .then((json) => {
        if(json?.status == 200) {
          DELETE_ROW(deletedLinkRowIndex);
          SUCCESSFUL_NOTIF()
        } else {
          DELETED_ERROR()
        }
    }).catch(() => {
      DELETED_ERROR()
    })
    
    CLOSE_CONFIRM_DELETION()
  };

  // Assign a specific class if the condition is true
  const rowClassRules = {
      // apply green to 2008
      'default-link': function(params: any) { return params.data.isDefault; }
  };

  const PAGE_SIZE_SELECTOR = useMemo(() => {
    return [15, 30, 45];
  }, []);

  const HEIGHT_COEFFICIENT_INT = WINDOWS_HEIGHT > DEFAULT_LINK_LIST_HEIGHT+WINDOWS_OVERHEAD ? DEFAULT_LINK_LIST_HEIGHT : WINDOWS_HEIGHT-WINDOWS_LIST_OVERHEAD;
  const HEIGHT_COEFFICIENT = HEIGHT_COEFFICIENT_INT.toString()+'px';

  const PAGE_NUMBER = WINDOWS_HEIGHT > DEFAULT_LINK_LIST_HEIGHT+WINDOWS_OVERHEAD ? DEFAULT_PAGE_NUMBER : Math.floor((WINDOWS_HEIGHT-WINDOWS_OVERHEAD)/LINE_HEIGHT);

  const HEIGHT_PERCENTAGE_INT = WINDOWS_HEIGHT > DEFAULT_LINK_LIST_HEIGHT+WINDOWS_OVERHEAD ? 100 : Math.floor(((WINDOWS_HEIGHT-WINDOWS_LIST_OVERHEAD)/WINDOWS_HEIGHT)*100);
  const HEIGHT_PERCENTAGE = HEIGHT_PERCENTAGE_INT.toString()+'%'

  var dataGridStyle = {
    style: {
      width: '98%',
      height: HEIGHT_PERCENTAGE,
      fontSize: '1rem'
    }
  }

  return (
    <>
    <LoadingScreen displayed={loading} />
    <Container className='h-100'>
      <Row className='h-auto'>
        <Col>
          <div className='mt-3 mb-3' style={{display: "flex", flexDirection: "row", alignItems: "center"}}>
            <h1 className='h1'>My Links</h1>
            <div style={{marginLeft: "auto"}}>
            <Button className="menu-button" bsPrefix="" variant="secondary" onClick={() => NAVIGATE("/link/create")}>Create a new link</Button>
            </div>
          </div>
          <div className='mt-3 mb-3' style={{height: HEIGHT_COEFFICIENT}}>
            <DataGrid
              ref={GRID_API}
              modules={AllCommunityModules}
              domLayout='domLayout'
              wrapperProps={dataGridStyle}
              rowData={rowData?.length == 0 ? [] : rowData}
              defaultColDef={{
                menuTabs: ['filterMenuTab']
              }}
              context={{
                token: ACCOUNT.token,
                displayConfirmDeletion: displayConfirmDeletion,
              }}
              overlayNoRowsTemplate="No link is saved"
              columnDefs={DATAGRID_COLUMNS_DEFS()}
              rowClassRules={rowClassRules}
              onFirstDataRendered = {(params) => {
                params.api.sizeColumnsToFit();
                params.api.resetRowHeights();
              }}
              pagination={true}
              paginationPageSize={PAGE_NUMBER}
              //paginationPageSizeSelector={PAGE_SIZE_SELECTOR}
            />
          </div>
        </Col>
      </Row>

      <Modal show={showConfirmDeletion} onHide={CLOSE_CONFIRM_DELETION}>
        <Modal.Header closeButton>
          <Modal.Title>Deletion : {deletedLinkName}</Modal.Title>
        </Modal.Header>
        <Modal.Body>Please click on "Confirm" button to delete this link</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={CLOSE_CONFIRM_DELETION}>
            Cancel
          </Button>
          <Button variant="primary" onClick={confirmDeletion}>
            Confirm
          </Button>
        </Modal.Footer>
      </Modal>
      </Container>
    </>

  );

};
